import { render } from "./PasswordReminderFormApp.vue?vue&type=template&id=94cee832"
import script from "./PasswordReminderFormApp.vue?vue&type=script&lang=js"
export * from "./PasswordReminderFormApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__